import { useEffect, useState } from "react"
import { Button, Icon } from "semantic-ui-react"

import { CashReception } from "../../models";
import { DistributorCashReceptionList, DistributorCashReceptionForm, LoadingSpinner, ErrorMessage } from "../../components"
import { DistributorService, HelperService } from "../../services"
import { FeedbackMessage } from "../../constants";

export function DistributorCashReceptionPage() {

    const [loadingData, setLoadingData] = useState(true)
    const [userRole, setUserRole] = useState<string>('')

    const [errorLoadingData, setErrorLoadingData] = useState(false)
    const [errorOpeningTill, setErrorOpeningTill] = useState(false)
    const [errorFetchingTillStatus, setErrorFetchingTillStatus] = useState(false)

    const [openingTill, setOpeningTill] = useState(false)
    const [isTillOpened, setIsTillOpened] = useState<boolean>(false)
    const [checkingTillStatus, setCheckingTillStatus] = useState(true)

    const [cashReceptions, setCashReceptions] = useState<CashReception[]>([])
    const [previousUnclosedTill, setPreviousUnclosedTill] = useState<any>(null)
    const [createModalVisible, setCreateModalVisible] = useState(false)

    useEffect(() => {

        setUserRole(HelperService.getRoleFromToken())

        DistributorService.getCashReceptionHistory()
            .then(data => setCashReceptions(data))
            .catch(err => setErrorLoadingData(true))
            .finally(() => setLoadingData(false))

        DistributorService.getMyTillStatus()
            .then(data => setIsTillOpened(data))
            .catch(err => setErrorFetchingTillStatus(true))
            .finally(() => setCheckingTillStatus(false))

        test()
    }, [])

    const addToList = (cashReception: CashReception) => setCashReceptions([cashReception, ...cashReceptions])

    const handleOpenTill = async () => {

        setOpeningTill(true)

        try {
            await DistributorService.openMyTill()
            setIsTillOpened(true)
        }
        catch (e: any) {
            const errMsg = e.response.data.message
            const errCode = e.response.status
            console.log(errCode, errMsg)
            setErrorOpeningTill(true)
        }
        finally {
            setOpeningTill(false)
        }
    }

    const test = () => {
        Promise.all([
            DistributorService.getMyTillStatus(),
            DistributorService.getPreviousDailyReport(),
        ]).then(([tillStatus, dailyReport]) => {
            console.log(tillStatus)
            console.log(dailyReport)
        }
        )
    }

    return <div style={{ width: '80%', margin: 'auto' }}>

        {checkingTillStatus && <LoadingSpinner />}
        {errorLoadingData && <ErrorMessage errorText={FeedbackMessage.CASH_RECEPTION_FETCH_ERROR} />}
        {errorOpeningTill && <ErrorMessage errorText={FeedbackMessage.TILL_OPENING_ERROR} />}
        {errorFetchingTillStatus && <ErrorMessage errorText={FeedbackMessage.TILL_STATUS_FETCH_ERROR} />}

        {
            !checkingTillStatus && isTillOpened &&
            <div>

                <div className='headerRow'>
                    <span></span>
                    {
                        userRole === 'Distributeur' &&
                        <Button color='orange' className='size-16' onClick={() => setCreateModalVisible(!createModalVisible)}>
                            {!createModalVisible && <Icon name="cart arrow down" />}
                            {createModalVisible ? 'Annuler' : "Recevoir de l'argent"}
                        </Button>
                    }
                </div>

                <div style={
                    {
                        height: createModalVisible ? '380px' : '0px',
                        overflow: 'hidden',
                        transition: 'height 0.5s ease-in-out',
                        marginBottom: createModalVisible ? '30px' : '0px'
                    }}>
                    <DistributorCashReceptionForm addToList={addToList} />
                </div>

                <br />

                {loadingData && <LoadingSpinner />}
                {!loadingData && !errorLoadingData && <DistributorCashReceptionList cashReceptions={cashReceptions} userRole={userRole} />}

            </div>
        }

        {
            !checkingTillStatus && !isTillOpened &&
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
                <h2>Votre caisse est fermée</h2>
                <p className="size-17">Vous devez ouvrir votre caisse pour pouvoir recevoir de l'argent</p>
                <br />
                <br />
                <br />
                <Button size='huge' secondary onClick={handleOpenTill} loading={openingTill}>
                    <Icon name='unlock alternate' />
                    Ouvrir ma caisse <Icon name='arrow alternate circle right outline' />
                </Button>
            </div>
        }

    </div>
}